var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formContainer" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.reset_password"),
            "close-on-click-modal": false,
            visible: _vm.$store.state.user.isShowModPwdModal,
            width: "509px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.$store.state.user,
                "isShowModPwdModal",
                $event
              )
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("system.password_details")) + " "),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("tips.update_your_password_entering_new_one")) +
                " "
            ),
          ]),
          _c("pwd-form", {
            key: "pwdForm",
            ref: "pwdForm",
            on: {
              changeModalStatus: _vm.changeModalStatus,
              changeStepStatus: _vm.changeStepStatus,
            },
          }),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }